import styled from "styled-components";
import { BodyDefault, HeadLine1 } from "../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px 50px 30px;
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 10px 16px 32px;
  }
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-top: 20px;
  margin-bottom: 20px;
`
export const FormWrapper = styled.div`
  display:flex;
  flex-direction: column;
  gap:20px;
  width: 360px;
  max-width: 100%;
  align-items: flex-start;
`

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  min-width: 0;
  margin-top: 40px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    margin-top: 24px;

    > button {
      flex: 1 1 140px;
    }
  }
`
